export const visibilityProducts = [
  {
    icon: 'car',
    title: 'Locação de veículos',
    description: 'Sistema completo para gerenciar frota e reservas.',
    href: 'https://fastcar-locacao.vercel.app/',
    isNew: true,
  },
  {
    icon: 'headset',
    title: 'Sistema de chamados',
    description: 'Atendimento e suporte técnico organizado.',
    href: 'https://systemchamados.netlify.app/',
    isNew: true,
  },
  {
    icon: 'shopping-bag',
    title: 'E-commerce',
    description: 'Loja virtual personalizada para o seu negócio.',
    href: 'https://sexshopproducts.netlify.app',
  },
  {
    icon: 'tool',
    title: 'Cardápio digital',
    description: 'Delivery e cardápio online para restaurantes.',
    href: 'https://cardapio-dig.netlify.app/',
  },
  {
    icon: 'car-garage',
    title: 'Vitrine de carros',
    description: 'Exiba seu estoque de veículos online.',
    href: 'https://vitrine-cars.netlify.app',
  },
  {
    icon: 'layout-grid',
    title: 'Catálogo digital',
    description: 'Apresente seus produtos com elegância.',
    href: 'https://catalago.netlify.app',
  },
]

export const gameProducts = [
  {
    icon: 'trophy',
    title: 'Votação com ranking',
    description: 'Sistema de votação estilo Game of Thrones.',
    href: 'https://ranking-of-thrones.netlify.app/',
    // isNew: true,
    // comingSoon: true,
  },
  {
    icon: 'help',
    title: 'Crie seu quiz',
    description: 'Quiz interativo personalizado para engajar seu público.',
    href: 'https://quizz-dev.netlify.app',
  },
  {
    icon: 'squares',
    title: 'Jogo da memória',
    description: 'Crie um jogo da memória com seu tema favorito.',
    href: 'https://dragonmemory.netlify.app',
  },
]

export const securityProducts = [
  {
    icon: 'shield',
    title: 'Ferramentas de segurança',
    description: 'Proteção avançada para sistemas e dados.',
    // isNew: true,
    // comingSoon: true,
  },
  {
    icon: 'bug',
    title: 'Scan de vulnerabilidades',
    description: 'Identifique brechas antes que virem problemas.',
    // isNew: true,
    // comingSoon: true,
  },
  {
    icon: 'network',
    title: 'Portas abertas',
    description: 'Analise a exposição de rede do seu sistema.',
    // isNew: true,
    // comingSoon: true,
  },
]
